import React from "react";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { getStripe } from "@/lib/stripe";

interface Props {
  fetchClientSecret: () => Promise<string>;
}

/**
 * Wraps Stripe's embedded checkout. The parent provides a stable
 * fetchClientSecret callback; we use it as the React `key` so the provider
 * remounts cleanly when checkout context changes.
 */
export const StripeEmbeddedCheckoutMount: React.FC<Props> = ({
  fetchClientSecret,
}) => {
  return (
    <div id="checkout" className="min-h-[500px]">
      <EmbeddedCheckoutProvider
        stripe={getStripe()}
        options={{ fetchClientSecret }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};

export default StripeEmbeddedCheckoutMount;
